import React, { useEffect } from "react";
import { Controlled as CodeMirror } from "react-codemirror2";
import Styles from "../styles/sorting/CodeView.module.css";
import { MdContentCopy } from "react-icons/md";
import CryptoJS from "crypto-js";
require("codemirror/mode/xml/xml");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/css/css");
require("codemirror/mode/jsx/jsx");
require("codemirror/lib/codemirror.css");
require("codemirror/theme/dracula.css");
require("codemirror/theme/panda-syntax.css");
require("codemirror/theme/material-ocean.css");
require("./theme.css");

const DEFAULT_JSX_OPTIONS = {
  theme: "material-ocean",
  autoCloseBrackets: true,
  cursorScrollMargin: 48,
  mode: "jsx",
  lineNumbers: true,
  indentUnit: 2,
  tabSize: 2,
  styleActiveLine: true,
  viewportMargin: 99,
  readOnly: true,
};

function CodeViewComponent({ ...data }) {
  const [copied, setCopied] = React.useState(false);
  const handleChange = () => {};

  useEffect(() => {
    console.log(data.code);
  }, [data.code]);

  const copyToClipBoard = (code: string): void => {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = code;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    setCopied(true);
  };

  const format = (): void => {};

  return (
    <div className={Styles.container}>
      <MdContentCopy
        size={25}
        color={copied ? "#40404c" : "#fff"}
        className={Styles.icon}
        onClick={() => copyToClipBoard(data.code)}
      />
      <CodeMirror
        value={data.code}
        options={DEFAULT_JSX_OPTIONS}
        onBeforeChange={handleChange}
      />
    </div>
  );
}

export default CodeViewComponent;
